import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Card, Button, Typography, Divider, Avatar, Tooltip } from "@material-ui/core";
import { inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import CardContent from "@material-ui/core/CardContent";

import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import StarIcon from "@material-ui/icons/Star";
import AddIcon from "@material-ui/icons/Add";
import EventIcon from "@material-ui/icons/Event";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

import "./SearchCard.css";
import { ProfileType } from "../../types/enum";
import BookingOptionModal from "./modal/BookingOptionModal";
import StaffAgentInvitationModal from "../venue/agentRoster/StaffAgentInvitationModal";
import AddMusicianToGigModal from "./modal/AddMusicianToGigModal";
import AddMusicianToActRosterModal from "./modal/AddMusicianToActRosterModal";
import ApplyToPlayModal from "./modal/ApplyToPlayModal";
import image from "../../helper/image";
import MessageModal from "../../components/profile/messageModal/MessageModal";
import MediaPreviewModal from "../modal/MediaPreviewModal";

@withRouter
@inject("agentMusicianStore", "profileStore", "agentVenueStore", "conversationStore")
class ManagedActSearchCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBookingOptionModal: false,
            showInvitationModal: false,
            showMusicianGigInvitationModal: false,
            showMusicianActInvitationModal: false,
            showApplyToPlayModal: false,
            showMessageModal: false,
            profileImage: image.getProfileImage(this.props.profile),
            showVideoModal: false,
            showAudioModal: false,
            showGalleryModal: false
        };
    }

    handleOpenVideoModal = () => {
        this.setState({ showVideoModal: true });
    };

    handleCloseVideoModal = () => {
        this.setState({ showVideoModal: false });
    };

    handleOpenAudioModal = () => {
        this.setState({ showAudioModal: true });
    };

    handleCloseAudioModal = () => {
        this.setState({ showAudioModal: false });
    };

    handleOpenGalleryModal = () => {
        this.setState({ showGalleryModal: true });
    };

    handleCloseGalleryModal = () => {
        this.setState({ showGalleryModal: false });
    };

    showBookingOptionModal = () => {
        this.setState({
            ...this.state,
            showBookingOptionModal: true
        });
    };

    showMessageModal = () => {
        this.setState({
            showMessageModal: true
        });
    };

    handleButtonMail = (e) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        if(currentProfile?.id === e.actAdminId) {
            // e.preventDefault();
            this.props.history.push('/messages/new');
        } else {
            if (currentProfile) {
                // e.preventDefault();
                this.props.history.push({
                    pathname: '/messages/new',
                    state: { profile: e?.actAdmin }
                })
            } else {
                this.setState({showMessageModal: true})
            }
        }
    }

    hideMessageModal = () => {
        this.setState({
            showMessageModal: false
        });
    };

    hideBookingOptionModal = () => {
        this.setState({
            ...this.state,
            showBookingOptionModal: false
        });
    };

    showInvitationModal = () => {
        const { type, profile, profileName, profileImage } = this.props;

        const { currentProfile } = this.props.profileStore;
        if (type === "agent" && currentProfile?.type === ProfileType.Staff.ordinal) {
            this.props.agentVenueStore.setInvitedProfile({
                ...profile,
                fullName: profileName
            });
        }
        this.setState({
            ...this.state,
            showInvitationModal: true
        });
    };

    hideInvitaionModal = () => {
        this.setState({
            ...this.state,
            showInvitationModal: false
        });
    };

    showMusicianGigInvitationModal = () => {
        this.setState({
            ...this.state,
            showMusicianGigInvitationModal: true
        });
    };

    hideMusicianGigInvitationModal = () => {
        this.setState({
            ...this.state,
            showMusicianGigInvitationModal: false
        });
    };

    showMusicianActInvitationModal = () => {
        this.setState({
            ...this.state,
            showMusicianActInvitationModal: true
        });
    };

    handleButtonMessage = (e) => {

        this.props.conversationStore.resetModal()
        this.setState({showMessageModal: true})
    }

    hideMusicianActInvitationModal = () => {
        this.setState({
            ...this.state,
            showMusicianActInvitationModal: false
        });
    };

    
    showApplyToPlayModal = () => {
        this.setState({
            ...this.state,
            showApplyToPlayModal: true
        });
    };

    hideApplyToPlayModal = () => {
        this.setState({
            ...this.state,
            showApplyToPlayModal: false
        });
    };
    getLineupName = (count) => {
    
        if(count === 1){
            return "Solo"
        }else if(count === 2){
            return "Duo"
        }else if(count === 3){
            return "Trio"
        }else if(count === 4){
            return "Quartet / 4 Piece"
        }else if(count === 5){
            return "Quintet / 5 Piece"
        }else if(count === 6){
            return "Sextet / 6 Piece"
        }
    }

    isNewAct = (profile) => {
        if (!profile?.createdDate) return false;
        const weeksAgo = moment().subtract(4, 'weeks');
        return moment(profile.createdDate).isAfter(weeksAgo);
    }

    parseVideoUrlString = (urlString) => {
    if (!urlString || typeof urlString !== 'string') return [];
    return urlString
        .split(" ||| ")
        .map(url => url.trim())
        .filter(url => url.length > 0)
        .map((url, index) => ({ id: `video-${index}`, url }));
    };
    getMediaCounts = (profile) => {
        return {
            videos: this.parseVideoUrlString(profile?.videoUrl).length,
            sounds: profile?.soundCount || profile?.sounds?.length || (profile?.musicUrl ? 1 : 0),
            photos: profile?.photoCount || profile?.photos?.length || profile?.galleryImages?.length || profile?.backgroundImages?.length || 0
        };
    }

    getVideos = (profile) => {
        return this.parseVideoUrlString(profile?.videoUrl)
    }

    getPhotos = (profile) => {
        if (profile?.photos && profile.photos.length > 0) {
            return profile.photos;
        }
        if (profile?.galleryImages && profile.galleryImages.length > 0) {
            return profile.galleryImages;
        }
        if (profile?.backgroundImages && profile.backgroundImages.length > 0) {
            return profile.backgroundImages;
        }
        return [];
    }

    getAudioData = (profile) => {
        const sounds = [];
        if (profile?.sounds && profile.sounds.length > 0) {
            sounds.push(...profile.sounds);
        }
        if (profile?.musicUrl) {
            sounds.push({ url: profile.musicUrl });
        }
        return sounds;
    }

    renderMediaBar = (profile) => {
        const media = this.getMediaCounts(profile);

        return (
            <div className="media-bar">
                <button 
                    className={`media-icon-btn ${media.videos > 0 ? 'has-media' : 'disabled'}`}
                    title={media.videos > 0 ? `Watch Videos (${media.videos})` : 'No Videos'}
                    disabled={media.videos === 0}
                    onClick={media.videos > 0 ? this.handleOpenVideoModal : undefined}
                >
                    <PlayArrowIcon />
                    {media.videos > 0 && <span className="media-count">{media.videos}</span>}
                </button>
                <button 
                    className={`media-icon-btn ${media.sounds > 0 ? 'has-media' : 'disabled'}`}
                    title={media.sounds > 0 ? 'Listen to Audio' : 'No Audio'}
                    disabled={media.sounds === 0}
                    onClick={media.sounds > 0 ? this.handleOpenAudioModal : undefined}
                >
                    <MusicNoteIcon />
                </button>
                <button 
                    className={`media-icon-btn ${media.photos > 0 ? 'has-media' : 'disabled'}`}
                    title={media.photos > 0 ? `View Photos (${media.photos})` : 'No Photos'}
                    disabled={media.photos === 0}
                    onClick={media.photos > 0 ? this.handleOpenGalleryModal : undefined}
                >
                    <PhotoLibraryIcon />
                    {media.photos > 0 && <span className="media-count">{media.photos}</span>}
                </button>
            </div>
        );
    }

    renderMetaTags = (profile) => {
        const tags = [];
        
        if (profile?.genreName) {
            const genres = profile.genreName.split(',').map(g => g.trim()).filter(g => g);
            genres.slice(0, 2).forEach((genre, idx) => {
                tags.push(<span key={`genre-${idx}`} className="meta-tag genre">{genre}</span>);
            });
        }
        
        if (profile?.lineUpCount) {
            tags.push(<span key="lineup" className="meta-tag">{this.getLineupName(profile.lineUpCount)}</span>);
        }
        
        if (profile?.vibesName) {
            const vibes = profile.vibesName.split(',').map(v => v.trim()).filter(v => v);
            if (vibes.length > 0) {
                tags.push(<span key="vibe" className="meta-tag">{vibes[0]}</span>);
            }
        }
        
        return tags.length > 0 ? <div className="card-meta">{tags}</div> : null;
    }
    render() {
        const { showBookingOptionModal, showInvitationModal, showMusicianGigInvitationModal, showMusicianActInvitationModal, showApplyToPlayModal, profileImage } = this.state;

        const { type, profileName,  profileBio, profileUrl, profileId, profile, isFavourite } = this.props;
        const { currentProfile } = this.props.profileStore;
        const isNew = this.isNewAct(profile);
        
        return (
            <Card className="manage-act search-card-enhanced" raised={false} style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "#3A3B3D" }}>
                <div
                    className="act-background-image"
                    style={{
                        backgroundImage: `url(${image.getBackgroundImage(this.props.profile)})`
                    }}
                >
                    {isNew && (
                        <span className="new-badge">
                            <StarIcon style={{ fontSize: 12 }} /> NEW
                        </span>
                    )}
                    <button 
                        className={`favorite-btn ${isFavourite ? 'active' : ''}`}
                        onClick={this.props.handleAddRemoveFavourite}
                        title={isFavourite ? 'Remove from Favorites' : 'Add to Favorites'}
                    >
                        {isFavourite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                    </button>
                    {this.renderMediaBar(profile)}
                    <Avatar className="act-avatar" aria-label={profileName} src={image.getProfileImage(this.props.profile)} />
                </div>
                <CardContent className="card-content-centered">
                    <h3 className="card-name-centered">
                        <Link to={profileUrl}>{profileName}</Link>
                    </h3>
                    {this.renderMetaTags(profile)}
                    <div className="card-stats-grid">
                        <div className="stat-item">
                            <div className="stat-value">{profile.completedBookingSum || 0}</div>
                            <div className="stat-label">Gigs Played</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-value">{Math.round(profile.totalHours || 0)}h</div>
                            <div className="stat-label">Hours Played</div>
                        </div>
                    </div>
                </CardContent>
                <div className="card-actions-row">
                    {type === "act" && (currentProfile?.type === ProfileType.Agent.ordinal || currentProfile?.type === ProfileType.Staff.ordinal) ? (
                        <Fragment>
                            <Tooltip
                                disableHoverListener={profile.canInvite}
                                title={profile.canInvite ? "" : "Already on your act roster."}
                                placement="bottom"
                            >
                                <span style={{ flex: 1 }}>
                                    <button 
                                        className="card-action-btn primary" 
                                        disabled={!profile.canInvite} 
                                        onClick={this.props.handleInvite}
                                        style={{ width: '100%' }}
                                    >
                                        <AddIcon style={{ fontSize: 16 }} /> Add Act
                                    </button>
                                </span>
                            </Tooltip>
                            <Tooltip
                                disableHoverListener={profile.isAvailable}
                                title="Act is not available on selected date/time."
                                placement="bottom"
                            >
                                <span style={{ flex: 1 }}>
                                    <button 
                                        className="card-action-btn" 
                                        disabled={!profile.isAvailable} 
                                        onClick={this.showBookingOptionModal}
                                        style={{ width: '100%' }}
                                    >
                                        <EventIcon style={{ fontSize: 16 }} /> Book
                                    </button>
                                </span>
                            </Tooltip>
                            <button className="card-action-btn" onClick={() => this.handleButtonMail(profile)}>
                                <MailOutlineIcon style={{ fontSize: 16 }} />
                            </button>
                            <BookingOptionModal unShowPrivate={currentProfile?.type === ProfileType.Staff.ordinal ? true : false} open={showBookingOptionModal} onClose={this.hideBookingOptionModal} actId={profileId} />
                            <MessageModal profile={profile} open={this.state.showMessageModal} closeHandler={this.hideMessageModal} />
                        </Fragment>
                    ) : null}

                    {type === "act" && (currentProfile?.type === ProfileType.PrivateHire.ordinal) ? (
                        <Fragment>
                            <Tooltip
                                disableHoverListener={profile.canInvite}
                                title={profile.canInvite ? "" : "Already on your act roster."}
                                placement="bottom"
                            >
                                <span>
                                    <Button size="small" color="default" onClick={this.props.handleAddRemoveFavourite}>
                                        {this.props.isFavourite ? "Remove as Favourite" : "Add as Favourite" }
                                    </Button>
                                </span>
                            </Tooltip>
                            <Tooltip
                                title="Request a quote from this act"
                                placement="bottom"
                            >
                                <span>
                                    <Button variant="raised" color="primary" className="actionButton" onClick={(e) => {
                                            this.handleButtonMessage(e)
                                            }} >
                                        Request a Quote
                                    </Button>
                                </span>
                            </Tooltip>
                            <MessageModal profile={profile} open={this.state.showMessageModal} closeHandler={this.hideMessageModal} />
                        </Fragment>
                    ) : null}

                    {type === "agent" && currentProfile?.type === ProfileType.Musician.ordinal ?
                        <Tooltip
                            disableHoverListener={profile.isAvailable}
                            title="Agent not open to an invitation or already on my agents."
                            placement="bottom"
                            >
                            <span>
                                <Button size="small" color="default" disabled={!profile.allowInvitesFromMusician} onClick={this.showApplyToPlayModal}>
                                    Apply to Play
                                </Button>
                            </span>
                        </Tooltip> : null
                    }

                    {type === "musician" && currentProfile?.type === ProfileType.Musician.ordinal ? (
                        <Fragment>
                            <Button size="small" color="default" onClick={this.showMusicianActInvitationModal}>
                                Invite to Act
                            </Button>
                            <Tooltip
                                disableHoverListener={profile.isAvailable}
                                title="Musician is not available on selected date/time."
                                placement="bottom"
                            >
                                <span>
                                    <Button
                                        size="small"
                                        color="default"
                                        disabled={!profile.isAvailable}
                                        onClick={this.showMusicianGigInvitationModal}
                                    >
                                        Invite to Gig
                                    </Button>
                                </span>
                            </Tooltip>
                            <AddMusicianToGigModal
                                open={showMusicianGigInvitationModal}
                                onClose={this.hideMusicianGigInvitationModal}
                                profileName={profileName}
                                profileImage={profileImage}
                                profile={profile}
                            />
                            <AddMusicianToActRosterModal
                                open={showMusicianActInvitationModal}
                                onClose={this.hideMusicianActInvitationModal}
                                profileName={profileName}
                                profileImage={profileImage}
                                profile={profile}
                                filterActMusician={true}
                            />
                            
                        </Fragment>
                    ) : null}

                    {
                        (type === "venue" || type === "agent") && currentProfile?.type === ProfileType.Musician.ordinal && profile.allowInvitesFromMusician && (
                            
                            <ApplyToPlayModal
                                open={showApplyToPlayModal}
                                onClose={this.hideApplyToPlayModal}
                                profileName={profileName}
                                profileImage={profileImage}
                                profile={profile}
                            />
                            
                        )
                    }
                    {type === "venue" && (currentProfile?.type === ProfileType.Agent.ordinal) ? (
                        <Tooltip disableHoverListener={profile.canInvite} title="Already on your venue roster." placement="bottom">
                            <span>
                                <Button size="small" color="default" disabled={!profile.canInvite} onClick={this.props.handleInvite}>
                                    Apply To Book
                                </Button>
                            </span>
                        </Tooltip>
                    ) : null}
                    
                    {type === "venue" && currentProfile?.type === ProfileType.Musician.ordinal && profile.allowInvitesFromMusician  && (
                        // <Tooltip disableHoverListener={!profile.allowInvitesFromMusician} title="Venue not open to an invitation or already on your venue act roster." placement="bottom">
                            <span>
                                <Button size="small" color="default"   onClick={this.showApplyToPlayModal} >
                                    Apply to Play
                                </Button>
                            </span>
                        // </Tooltip>
                    )}
                    {type === "agent" && currentProfile?.type === ProfileType.Staff.ordinal ? (
                        <Fragment>
                            <Button size="small" color="default" onClick={this.showInvitationModal}>
                                Invite Agent
                            </Button>
                            <StaffAgentInvitationModal open={showInvitationModal} onClose={this.hideInvitaionModal} />
                        </Fragment>
                    ) : null}

                </div>
                
                <MediaPreviewModal
                    open={this.state.showVideoModal}
                    onClose={this.handleCloseVideoModal}
                    type="videos"
                    profileName={profileName}
                    videos={this.getVideos(profile)}
                />
                <MediaPreviewModal
                    open={this.state.showAudioModal}
                    onClose={this.handleCloseAudioModal}
                    type="audio"
                    profileName={profileName}
                    sounds={this.getAudioData(profile)}
                />
                <MediaPreviewModal
                    open={this.state.showGalleryModal}
                    onClose={this.handleCloseGalleryModal}
                    type="gallery"
                    profileName={profileName}
                    photos={this.getPhotos(profile)}
                />
            </Card>
        );
    }
}

export default ManagedActSearchCard;
